<template>
  <div class="box">
    <span class="title-text" style="margin: 10px 0 0 25px;">送样指南</span>
    <div v-if="sampleDeliveryInfo && sampleDeliveryInfo.length > 0">
      <div v-for="(initFile,index) in sampleDeliveryInfo" :id="index">
        <div class="file-content" @click="downSampleInfoFile(initFile)">
          <div class="layer1">
            <img class="word-icon" :src="emkt.getOrderMaterialFileShowIcon(initFile.fileName)" />
            <div class="layer2 flex-col">
              <span class="file-font">{{ initFile.fileName }}</span>
              <span class="file-font" style="margin-top: 2px;">{{ initFile.fileSizeDisplay }}</span>
            </div>
            <img class="right-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'"/>
          </div>
        </div>
      </div>
      <span class="word" style="margin: 5px 15px 0px 15px;">请务必仔细阅读《物品寄送指南》并按照指南收集样本</span>
    </div>
    <div v-else style="margin-left: 25px;"><span class="word" style="color: #FE654D;">{{getMaterialWarning()}}</span></div>
    <div class="sample-info-class">
      <span class="title-text">实物信息表</span>
      <span class="show-txt" @click="showMaterialSendProcess">查看实物寄送流程</span>
    </div>
    <div v-for="(initFile,index) in sampleInfo" :id="index">
      <div class="file-content" @click="downSampleInfoFile(initFile)">
        <div class="layer1">
          <img class="word-icon" :src="emkt.getOrderMaterialFileShowIcon(initFile.fileName)" />
          <div class="layer2 flex-col">
            <span class="file-font">{{ initFile.fileName }}</span>
            <span class="file-font" style="margin-top: 2px;">{{ initFile.fileSizeDisplay }}</span>
          </div>
          <img class="right-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'"/>
        </div>
      </div>
    </div>
    <div class="goods-info-class">
      <span class="word">请完整填写《实物信息表》全部相关信息，寄送实物，将文档直接上传，字迹清晰可辨。推荐在电脑端使用小程序完成上传操作。</span>
      <span class="word8" @click="showMiniProgramInComputerUsage">查看小程序在电脑端的使用方法</span>
    </div>
    <div class="sample-delivery-record">
      <span class="info4">寄送记录</span>
      <span class="show-txt" @click="showSampleDeliverySheet">查看寄送记录</span>
    </div>
    <div v-for="(materialExpress,index) in materialDetail.orderMaterialExpressList" :id="index">
      <div class="group1 flex-col">
        <div class="flex-col">
          <div class="group2 flex-row">
            <span class="express" v-if="materialExpress.expressNo !== ''">快递单号：{{ materialExpress.expressNo }}</span>
            <span class="express" v-else>快递单号：待填写</span>
            <div style="margin-top: 9px">
              <display-icon-and-status  :displayStatusName = materialExpress.displayStatusName :displayType="emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE"></display-icon-and-status>
            </div>
          </div>
          <div class="line"></div>
          <div class="layer3 flex-row">
            <display-icon-and-status :materialType = materialDetail.orderMaterial.materialType :displayType="emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON"></display-icon-and-status>
            <span class="txt">{{ materialDetail.orderMaterial.materialDesc }}</span>
            <span class="status">{{ materialExpress.expressMaterialDetailList[0].displayStatusName }}</span>
          </div>
          <div class="line"></div>
          <div class="create-dt-class">
            <span class="word" style="margin: 5px 0 0 15px;">创建时间：{{ materialExpress.createDT }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="block"></div>
      <span class="end-txt">我是有底线的</span>
      <div class="block"></div>
    </div>
  </div>
</template>
<script>
  import wx from 'wx'
  import EMKT from '../../emkt'
  import DisplayIconAndStatus from './DisplayIconAndStatus'
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'MaterialDetail',
    components: {DisplayIconAndStatus},
    computed: {
      ...mapState(['sessionInfo']),
      ...mapGetters(['getOrderMaterialInfo', 'getOrderMaterialId']),
      'sampleDeliveryInfo': function () {
        if (this.materialDetail.initFileList && this.materialDetail.initFileList.length > 0) {
          return this.materialDetail.initFileList.filter(i => i.fileType === EMKT.MATERIAL_FILETYPE.SAMPLE_DELIVERY_GUIDE)
        }
      },
      'sampleInfo': function () {
        if (this.materialDetail.initFileList && this.materialDetail.initFileList.length > 0) {
          return this.materialDetail.initFileList.filter(i => i.fileType === EMKT.MATERIAL_FILETYPE.SAMPLE_INFO_SHEET)
        }
      }
    },
    created () {
      this.fetchData()
    },
    activated () {
      this.fetchData()
    },
    data () {
      return {
        materialDetail: {}
      }
    },
    methods: {
      fetchData () {
        this.gcapi('loadOrderMaterialInfo', this.getOrderMaterialInfo[0].orderMaterial.orderNo).then((res) => {
          if (res.body.result !== '[]') {
            this.orderMaterialInfo = JSON.parse(res.body.result)
            this.materialDetail = this.orderMaterialInfo.find(material => material.orderMaterial.orderMaterialId === this.getOrderMaterialId)
          }
        })
      },
      getMaterialWarning () {
        if (this.materialDetail.orderMaterial && this.materialDetail.orderMaterial.materialWarning !== undefined) return this.materialDetail.orderMaterial.materialWarning
      },
      downSampleInfoFile (file) {
        wx.miniProgram.navigateTo({
          url:
            '/pages/file/downloadSampleInfoFile?customerNo=' +
            this.sessionInfo.customerInfo.customerNo +
            '&fileName=' +
            file.fileName.replace('&', '%26') +
            '&fileType=' +
            EMKT.getFileSuffix(file.fileName) +
            '&fileSize=' +
            file.fileSizeDisplay +
            '&orderMaterialDetailId=' +
            file.orderMaterialDetailId
        })
      },
      showMiniProgramInComputerUsage () {
        this.$router.push({
          name: 'ComputerSideUsage'
        })
      },
      showMaterialSendProcess () {
        this.$router.push({
          name: 'MaterialSendProcess'
        })
      },
      showSampleDeliverySheet () {
        this.$weui.loading('加载中')
        let params = {json: this.getOrderMaterialInfo[0].orderMaterial.orderNo, method: 'loadOrderMaterialExpress'}
        this.gcapi('invokeBsmMethod', params).then((res) => {
          this.$router.push({
            name: 'MySampleDeliverySheet',
            params: {orderMaterialExpressList: JSON.parse(res.body.result)}
          })
          this.$weui.loading('加载中').hide()
        })
      }
    }
  }
</script>

<style scoped>
  .box {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100vh;
    position: relative;
    padding: 10px;
    padding-bottom: 0;
    background-color: rgba(250, 250, 250, 1);
    justify-content: flex-start;
    padding-top: 0;
  }

  .title-text {
    width: 290px;
    height: 20px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    white-space: nowrap;
    line-height: 20px;
    text-align: left;
    align-self: flex-start;
  }

  .file-content {
    height: 79px;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    align-self: center;
    margin-top: 10px;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
    padding-left: 11px;
    display: flex;
    flex-direction: column;
  }

  .layer1 {
    width: 90%;
    margin-left: 15px;
    position: relative;
    display: flex;
    flex-direction: row;
  }

  .word-icon {
    width: 44px;
    height: 40px;
  }

  .layer2 {
    width: 100%;
    height: 36px;
    margin: 2px 0 0 10px;
  }

  .file-font {
    height: 30px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #424242;
    line-height: 17px;
  }

  .right-icon {
    width: 7px;
    height: 12px;
    top: 14px;
    right: -5px;
    position: absolute;
  }

  .word {
    color: rgba(146, 146, 146, 1);
    font-size: 12px;
    line-height: 19px;
    margin-top: 5px;
  }

  .sample-info-class {
    width: 90%;
    height: 21px;
    justify-content: space-between;
    margin: 15px 0 0 25px;
    display: flex;
    flex-direction: row;
  }

  .show-txt {
    width: 113px;
    height: 19px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(88, 120, 250, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 19px;
    text-align: right;
    margin-top: 2px;
  }

  .word8 {
    font-size: 12px;
    color: rgba(88, 120, 250, 1);
    line-height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .goods-info-class {
    height: 57px;
    overflow-wrap: break-word;
    text-align: justify;
    align-self: center;
    margin: 10px 15px 0px 15px;
    font-size: 0;
  }

  .sample-delivery-record {
    width: 90%;
    height: 21px;
    justify-content: space-between;
    margin: 20px 0 10px 25px;
    display: flex;
    flex-direction: row;
  }

  .info4 {
    z-index: 71;
    width: 69px;
    height: 20px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    white-space: nowrap;
    line-height: 20px;
    text-align: left;
  }

  .group1 {
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    margin-bottom: 10px;
    width: 100%;
    justify-content: flex-end;
    padding-bottom: 4px;
    position: relative;
  }

  .group2 {
    width: 90%;
    margin-left: 15px;
    justify-content: space-between;
  }

  .layer3 {
    width: 90.6%;
    height: 29px;
    justify-content: space-between;
    margin: 9px 0 0 15px;
  }

  .express {
    width: 159px;
    color: rgba(66, 66, 66, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 17px;
    text-align: left;
    margin-top: 11px;
  }

  .txt {
    width: 80%;
    color: rgba(66, 66, 66, 1);
    font-size: 13px;
    white-space: nowrap;
    line-height: 21px;
    text-align: justify;
    margin-top: 4px;
    margin-left: 10px;
  }

  .status {
    height: 14px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(254, 101, 77, 1);
    font-size: 10px;
    white-space: nowrap;
    line-height: 14px;
    text-align: left;
    margin-top: 8px;
  }

  .line {
    width: 100%;
    height: 1px;
    background: #EFEEF3;
    margin-top: 11px;
  }

  .create-dt-class {
    z-index: 76;
    width: 355px;
  }

  .footer {
    width: 118px;
    height: 17px;
    justify-content: space-between;
    margin: 43px 0 0 129px;
    display: flex;
  }

  .block {
    width: 15px;
    height: 1px;
    margin-top: 9px;
    background: #D2D2D6;
  }

  .end-txt {
    width: 72px;
    height: 17px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(210, 210, 214, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 17px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// MaterialDetail.vue?bcbf950e